import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import './design/theme.css'
import { App } from './App'
import { memoriserEnregistrement, surveillerLesVersions } from './lib/majApplication'
import { appliquerTheme, lireTheme } from './lib/theme'

// Le thème est posé avant le premier rendu. Il ne peut pas l'être par un script en ligne dans
// index.html : la politique de sécurité de contenu n'autorise que « script-src 'self' », et un
// script en ligne y serait bloqué. En « système » — le cas par défaut — aucun attribut n'est
// posé et c'est la requête de média qui décide, donc sans clignotement.
appliquerTheme(lireTheme())

/**
 * Enregistrement du service worker, avec reprise immédiate.
 *
 * Combiné à `skipWaiting` et `clientsClaim`, une version fraîchement déployée s'active sans
 * attendre, puis réclame les onglets déjà ouverts. Le rechargement qui suit est déclenché une
 * seule fois : sans ce garde-fou, une boucle est possible si le contrôleur change en cascade.
 */
registerSW({
  immediate: true,
  // L'enregistrement est conservé pour pouvoir redemander une vérification : « autoUpdate » ne
  // compare qu'au chargement de la page, ce qui ne se produit jamais dans une application
  // installée qu'on ne ferme pas.
  onRegisteredSW: (_url, registration) => memoriserEnregistrement(registration),
})

surveillerLesVersions()

if ('serviceWorker' in navigator) {
  let rechargement = false

  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (rechargement) {
      return
    }

    rechargement = true
    window.location.reload()
  })
}

const container = document.getElementById('root')
if (!container) {
  throw new Error("L'élément racine #root est absent de index.html.")
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
